"use client";
import ProductCard from "@/components/productCard/ProductCard";
import { Button } from "@/components/ui/button";
import useRenderProductRatings from "@/hooks/useRenderProductRating";
import TopDealIcon from "@/icons/TopDealIcon";
import { useGetProductListsQuery } from "@/redux/apiSlices/ProductListsApi";
import { useRouter } from "next/navigation";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import FeaturedProductSkeleton from "./FeaturedProductSkeleton";
import { useEffect, useState } from "react";

export const FeaturedProductsCard = () => {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) return;
  
    const updateCount = () => {
      setCount(api.scrollSnapList().length);
      setCurrent(api.selectedScrollSnap() + 1);
    };
  
    updateCount(); // Initial count and current slide set
  
    api.on("reInit", updateCount); // Ensure count updates on re-initialization
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  
    return () => {
      api.off("reInit", updateCount);
      api.off("select");
    };
  }, [api]);
  

  // Function to go to a specific slide when clicking a dot
  const goToSlide = (index) => {
    if (api) {
      api.scrollTo(index);
    }
  };

  const { data, isFetching } = useGetProductListsQuery({
    limit: 24,
    tag:'home'
  });
  const productListsData = data?.data || [];

  useRenderProductRatings(productListsData);

  return (
    <div className="max-w-[calc(100%-267px)] w-full lg:max-w-full">
      <Carousel
        opts={{ align: "start" }}
        className="w-full pb-[48px] lg:pb-6 "
        setApi={setApi}
      >
        <CarouselContent className="m-0">
          {isFetching
            ? Array.from({ length: 4 }).map((_, index) => (
                
                <CarouselItem
                  key={index}
                  className="basis-1/4 m-0 1300:basis-1/3 viewedCard820:basis-2/5 smd:basis-1/2 viewedCard570:basis-3/4 mob:basis-4/5"
                >
                  <div key={index} className="px-[7px] py-[10px]">
                  <FeaturedProductSkeleton key={index} />
                  </div>
                </CarouselItem>
              ))
            : productListsData?.length > 0 &&
              productListsData?.map((productList, index) => (
                <CarouselItem
                  key={index}
                  className="basis-1/4 m-0 1300:basis-1/3 viewedCard820:basis-2/5 smd:basis-1/2 viewedCard570:basis-3/4 mob:basis-4/5"
                >
                  <div key={index} className="px-[7px] py-[10px]">
                    <ProductCard
                      className=" shadow-[2px_4px_8px_0px_rgba(0,0,0,0.12)] border-0 min-h-[520px] mxl:pb-[22px] lg:min-h-[453px]   flex flex-col justify-between rounded-2xl border-gray5 px-[15px] pt-9 pb-[10px]"
                      productDetail={productList}
                      index={index}
                      type="short"
                    />
                  </div>
                </CarouselItem>
              ))}
        </CarouselContent>
        {!isFetching && (
          <div className=" grid grid-cols-[1fr_auto] items-center gap-3 pl-[9px] ">
            {/* Clickable Pagination Dots */}
            <div className="flex justify-center ">
              {Array.from({ length: count }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-full h-1  transition-all ${
                    current === index + 1 ? "bg-black" : "bg-[#D0D0D0]"
                  }`}
                />
              ))}
            </div>
            {/* Navigation Buttons */}
            <div className="flex items-center justify-end gap-3">
              <CarouselPrevious className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
              <div className="text-sm text-[#0C2340] font-medium">
                {current}/{count}
              </div>
              <CarouselNext className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
            </div>
          </div>
        )}
      </Carousel>
    </div>
  );
};

export const TopDealsCard = ({breadcrumHandler}) => {
  const router = useRouter();
  
  return (
    <div className="py-[10px] lg:hidden cursor-pointer" onClick={() => {
            router.push(`/top-deals`);
            breadcrumHandler();
          }}>
      <div className=" w-[260px] border-2 h-[520px]  rounded-2xl  py-5 flex flex-col justify-center items-start px-[33px] text-white bg-[#16365F]">
        <TopDealIcon />
        <h1 className=" text-[#FDB913] mt-5 text-[32px] max-w-[168px]	 leading-[42px] pb-5 mb-5 border-b-2 border-white inline-flex font-semibold">
          Featured <br /> Top Deals
        </h1>
        <p className=" text-[16px] leading-[21px] mb-6">
          Shop limited time deals on our best selling appliances.
          {/* Check out our exclusive selection of this season’s new arrivals, made
          with world’s highest quality */}
        </p>

         <p className=" text-[14px] leading-[21px] mb-6">
           Limited time pricing
        </p>
        <Button
          // onClick={() => {
          //   router.push(`/top-deals`);
          //   breadcrumHandler();
          // }}
          className=" bg-[#FDB913] text-[12px] text-[#414042] rounded-[7px] font-semibold border-0 hover:bg-white "
        >
          Shop All
        </Button>
      </div>
    </div>
  );
};